import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue";
import MiniCart from "@/components/MiniCart.vue";
import { useUserStore } from "@/stores/UserStore";
import { useSettingsStore } from "@/stores/SettingsStore";
import { useRouter } from "vue-router";
export default /*@__PURE__*/ _defineComponent({
    __name: 'KrumosHeader',
    setup(__props) {
        const userStore = useUserStore();
        const settingStore = useSettingsStore();
        const router = useRouter();
        function logout() {
            userStore.logout();
            router.push('/');
        }
        return (_ctx, _cache) => {
            const _component_v_app_bar_nav_icon = _resolveComponent("v-app-bar-nav-icon");
            const _component_v_container = _resolveComponent("v-container");
            const _component_v_app_bar_title = _resolveComponent("v-app-bar-title");
            const _component_v_spacer = _resolveComponent("v-spacer");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_app_bar = _resolveComponent("v-app-bar");
            return (_openBlock(), _createBlock(_component_v_app_bar, {
                id: "header",
                class: "d-flex"
            }, {
                default: _withCtx(() => [
                    (!!_unref(userStore).user.token)
                        ? (_openBlock(), _createBlock(_component_v_app_bar_nav_icon, {
                            key: 0,
                            "data-cy": "menu",
                            onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (_ctx.$emit('toggleDrawer')), ["stop"]))
                        }))
                        : _createCommentVNode("", true),
                    _createVNode(_component_v_app_bar_title, { class: "d-flex" }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_container, {
                                class: "pa-0 cursor-pointer",
                                onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.$router.push('/')))
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(settingStore).settings.get("store_name").value), 1)
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    }),
                    _createVNode(_component_v_spacer),
                    _createVNode(_component_v_container, { class: "d-flex pa-0 w-auto" }, {
                        default: _withCtx(() => [
                            _createVNode(MiniCart, {
                                "data-cy": "miniCart",
                                onClick: _cache[2] || (_cache[2] = ($event) => (_ctx.$router.push('/cart'))),
                                class: "cursor-pointer d-flex"
                            }),
                            (!!_unref(userStore).user.token)
                                ? (_openBlock(), _createBlock(_component_v_container, {
                                    key: 0,
                                    class: "d-flex text-no-wrap align-center"
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(" Logged in as: " + _toDisplayString(_unref(userStore).user.username), 1)
                                    ]),
                                    _: 1
                                }))
                                : _createCommentVNode("", true),
                            (!!_unref(userStore).user.token)
                                ? (_openBlock(), _createBlock(_component_v_container, { key: 1 }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_v_btn, { onClick: logout }, {
                                            default: _withCtx(() => _cache[3] || (_cache[3] = [
                                                _createTextVNode("Logout")
                                            ])),
                                            _: 1
                                        })
                                    ]),
                                    _: 1
                                }))
                                : _createCommentVNode("", true)
                        ]),
                        _: 1
                    })
                ]),
                _: 1
            }));
        };
    }
});
